export default "__VITE_ASSET__76ac48ea__"